import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';

interface Props {
    type: 'A' | 'B';
}

const BreakSpaceLimits: React.FC<Props> = (props) => {
    const { locale } = getLocal();
    const { t } = useLang('every_room');
    const { t: t2 } = useLang('spread');

    const map = {
        A: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748685422429/PowerStream%20System-tech.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748685422429/PowerStream%20System-tech.jpg',
            text: t('label'),
        },
        B: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748686374094/PowerStream%20Ultra-balcony%20(2).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748686374094/PowerStream%20Ultra-balcony%20(2).jpg',
            text: t2('label'),
        },
    };
    return (
        <div className={styles.BreakSpaceLimits}>
            <EcoImg pc={map[props.type].pc} pad={map[props.type].pad} />
            <div className="wrapper">
                <div className="title">{map[props.type].text}</div>
            </div>
        </div>
    );
};

export default BreakSpaceLimits;
